import { ColumnsType } from '@agro-club/agroclub-shared'
import formatNumber from 'modules/utils/numbers/formatNumber'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router'
import { removeSeconds } from 'views/pages/LogisticsKR/helpers'
import { TableTextLink } from 'views/ui/TableTextLink/TableTextLink'
import { BooleanCell } from '../../../../components/BooleanCell'
import WarehousesKRRoutes from '../../../routes'
import { AddressWrapper } from '../styled'

const useColumns = (): ColumnsType<any> => {
  const { t } = useTranslation('logisticsKR')

  return useMemo(
    () => [
      {
        title: t('warehouses.list.tableHeaders.address'),
        dataIndex: 'address',
        width: 562,
        render: (address, data) => (
          <AddressWrapper>
            <TableTextLink
              id="unloadingWarehouseLink"
              to={generatePath(WarehousesKRRoutes.Details, { id: data.id, type: 'unloading' })}
            >
              {address}
            </TableTextLink>
          </AddressWrapper>
        ),
      },
      {
        title: t('warehouses.list.tableHeaders.vehicle_type'),
        dataIndex: 'vehicle_type',
        width: 188,
        render: (vehicle_type) => vehicle_type.map((type) => t(`vehicle_type.${type}`)).join(', '),
      },
      {
        title: t('warehouses.list.tableHeaders.is_dump_truck'),
        dataIndex: 'is_dump_truck',
        width: 90,
        render: (is_dump_truck) => <BooleanCell field={is_dump_truck} />,
      },
      {
        title: t('warehouses.list.tableHeaders.volume_per_day'),
        dataIndex: 'volume_per_day',
        width: 144,
        align: 'right',
        render: (volume_per_day) => formatNumber(volume_per_day),
      },
      {
        title: t('warehouses.list.tableHeaders.unloading_type'),
        dataIndex: 'unloading_type',
        width: 188,
        render: (unloading_type) => t(`directions.${unloading_type}`),
      },
      {
        title: t('warehouses.list.tableHeaders.schedule'),
        dataIndex: 'schedule_from',
        width: 120,
        render: (schedule_from, data) => `${removeSeconds(schedule_from)}-${removeSeconds(data.schedule_to)}`,
      },
      {
        title: t('warehouses.list.tableHeaders.works_on_weekend'),
        dataIndex: 'works_on_weekend',
        width: 90,
        render: (works_on_weekend) => <BooleanCell field={works_on_weekend} />,
      },
      {
        title: t('warehouses.list.tableHeaders.car_delivery'),
        dataIndex: 'car_delivery',
        width: 56,
        render: (car_delivery) => <BooleanCell field={car_delivery} />,
      },
      {
        title: t('warehouses.list.tableHeaders.railway_delivery'),
        dataIndex: 'railway_delivery',
        width: 56,
        render: (railway_delivery) => <BooleanCell field={railway_delivery} />,
      },
    ],
    [t],
  )
}

export default useColumns
